import { useContext } from 'react';
import { AuthContext, AuthContextType } from './AuthenticationProvider';
import { User } from './user';

import {useLogoutFunction, useRedirectFunctions} from "@propelauth/react"

interface AuthProvider {
	signOut: () => void | Promise<void>;
	updateUser: (user: User) => void | (() => void);
}

type AuthProviders = {
	[key: string]: AuthProvider;
};

function useAuth(): AuthContextType & { signOut: () => void } {
	const context = useContext(AuthContext);
	const logout = useLogoutFunction();
	const { redirectToAccountPage } = useRedirectFunctions();

	if (!context) {
		throw new Error('useAuth must be used within a AuthRouteProvider');
	}

	const authProviders: AuthProviders = {
		propel: {
			signOut: async () => {
				try {
					await logout(true);
					window.location.href = '/sign-in';
				} catch (error) {
					console.error("Logout failed:", error);
				}
			},
			updateUser: () => redirectToAccountPage()
		}
	};

	const signOut = async () => {
		try {
			await logout(true);
			window.location.href = '/sign-in';
		} catch (error) {
			console.error("Logout failed:", error);
		}
	};

	const updateUser = (user: User) => {
		const authProvider = context.getAuthProvider();
		authProviders[authProvider]?.updateUser(user);
	};

	return { ...context, signOut, updateUser };
}

export default useAuth;


// // import { useContext } from 'react';
// import { AuthContext, AuthContextType } from './AuthenticationProvider';
// import { useAuthInfo, useSignOut } from '@propelauth/react';
// import { User } from './user';

// interface AuthProvider {
//     signOut: () => void;
//     updateUser: (user: User) => void;
// }

// type AuthProviders = {
//     [key: string]: AuthProvider;
// };

// function useAuth(): AuthContextType & { signOut: () => void } {
//     const context = useContext(AuthContext);
//     const authInfo = useAuthInfo();
//     const signOutPropelAuth = useSignOut();

//     if (!context) {
//         throw new Error('useAuth must be used within an AuthRouteProvider');
//     }

//     const authProviders: AuthProviders = {
//         propelauth: { 
//             signOut: signOutPropelAuth, 
//             updateUser: (user) => {
//                 // Implement updateUser logic for PropelAuth if available
//             } 
//         },
//     };

//     const signOut = () => {
//         const authProvider = context.getAuthProvider();
//         authProviders[authProvider]?.signOut();
//     };

//     const updateUser = (user: User) => {
//         const authProvider = context.getAuthProvider();
//         authProviders[authProvider]?.updateUser(user);
//     };

//     return { ...context, signOut, updateUser, isAuthenticated: authInfo.isLoggedIn };
// }

// export default useAuth;

